export enum HoursSectionType {
  NORMAL_HOURS = 'NORMAL_HOURS',
  CLOSED = 'CLOSED',
  SPECIAL_HOURS = 'SPECIAL_HOURS'
}
